// extracted by mini-css-extract-plugin
export default {"keyOperationalMetricsGrid":"KeyOperationalMetrics_keyOperationalMetricsGrid__1D2ZJ","lightWeight":"KeyOperationalMetrics_lightWeight__RXeIL"};